.CustomScrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;

  position: absolute;
}

.CustomScrollbar::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 8px;
}

.CustomScrollbar::-webkit-scrollbar-track {
  background: transparent;
}

/* Non-Standard, But More Styling-Capable Properties */

/* Standardized Properties */
@supports not selector(::-webkit-scrollbar) {
  .CustomScrollbar {
    scrollbar-color: #ccc transparent;
    scrollbar-width: thin;
  }
}
